import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/store/auth'

export const GuestRoute = () => {
  const hasHydrated = useAuthStore((state) => state._hasHydrated)
  const authToken = useAuthStore((state) => state.authToken)

  const isAuthenticated = !!authToken

  // Wait for hydration before making auth decisions
  if (!hasHydrated) {
    return null
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
